
import Vue from "vue";

export default Vue.extend({
  name: "AlertDialog",
  props: {
    width: Number,
    type: String,
    closeBtnText: String,
  },
  data: () => ({
    visible: false,
    title: "title",
    body: "body",
  }),
  methods: {
    open(slots?: { title?: string; body?: string }): void {
      this.visible = true;
      this.title = slots?.title || "title";
      this.body = slots?.body || "body";
    },
    close(): void {
      this.visible = false;
    },
  },
});
